import Vue from "vue";
import axios from "axios";
const apiCache = new Map();

export default {
    envPath: function() {
        // if (process.env.NODE_ENV === "development") {
        //     return "/api"; // 测试环境加上前缀，为了config/index.js里的测试环境代理proxyTable配置
        // }
        return "";
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    req: function(
        url,
        data,
        pSuccessCallback,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    ) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else if (pSuccessCallback != undefined) {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        pSuccessCallback.apply(_this, [response.data]);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    reqAsy: async function({
        url,
        data,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    }) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        return axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        // pSuccessCallback.apply(_this, [response.data]);
                        return response.data;
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    /**
     * req Command命令提交调用
     * @param {*} url
     * @param {*} data        要提交的参数
     */
    reqCache: function(
        url,
        data,
        method = "post",
        loadingFlag = true,
        ctype = "payload"
    ) {
        let cacheKey = data.cacheKey;
        if (cacheKey && apiCache.has(cacheKey)) {
            return apiCache.get(cacheKey);
        }

        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        if (ctype == "payload") {
            headers["Content-Type"] = "application/json; charset=utf-8";
        } else if (ctype == "formData") {
            headers["Content-Type"] = "application/x-www-form-urlencoded";
            let tmp = data;
            const formData = new FormData();
            for (const key in tmp) {
                if (tmp.hasOwnProperty(key)) {
                    if (tmp[key]) {
                        if (tmp[key].constructor === Array) {
                            if (tmp[key][0]) {
                                if (tmp[key][0].constructor === Object) {
                                    formData.append(
                                        key,
                                        JSON.stringify(tmp[key])
                                    );
                                } else {
                                    tmp[key].forEach((item, index) => {
                                        formData.append(
                                            key + `[${index}]`,
                                            item
                                        );
                                    });
                                }
                            } else {
                                formData.append(key + "[]", "");
                            }
                        } else if (tmp[key].constructor === Object) {
                            formData.append(key, JSON.stringify(tmp[key]));
                        } else {
                            formData.append(key, tmp[key]);
                        }
                    } else {
                        if (tmp[key] === 0) {
                            formData.append(key, 0);
                        } else {
                            formData.append(key, "");
                        }
                    }
                }
            }
            data = formData;
        }

        const promise = axios({
            url: url,
            method: method,
            data: data,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    if (
                        response.data &&
                        response.data.errorCode &&
                        response.data.errorCode == "401"
                    ) {
                        _this.$message({
                            showClose: true,
                            message: "登录过期，请重新登录",
                            type: "warning"
                        });
                        sessionStorage.clear();
                        _this.$router.push("/login");
                    } else {
                        let token = response.headers["hwt-token"];
                        if (token) {
                            sessionStorage.setItem("hwt-token", token);
                        }

                        // pSuccessCallback.apply(_this, [response.data]);
                        apiCache.set(cacheKey, response.data);
                        return response.data;
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "Error：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "Connect error[" + response.status + "]",
                        type: "warning"
                    });
                }
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                // console.log(err.response.status);
                if (loadingFlag) {
                    loading.close();
                }

                if (cacheKey) {
                    apiCache.delete(cacheKey); // 请求失败时移除缓存
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });

        // 将 Promise 临时存入缓存（避免重复请求）
        apiCache.set(cacheKey, promise);
        return promise;
    },
    /**
     * 导出 Command命令提交调用
     * @param {*} url
     * @param {*} pParameter        要提交的参数
     * @param {*} pSuccessCallback  成功时的回调
     */
    export: function(
        url,
        pParameter,
        pSuccessCallback,
        method = "post",
        loadingFlag = true
    ) {
        var _this = this;
        if (process.env.NODE_ENV === "development") {
            url = config.apiHost + url;
        } else if (process.env.NODE_ENV === "production") {
            url = "/api" + url;
        }

        let loading;
        if (loadingFlag) {
            loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        }

        let headers = {};
        if (sessionStorage.getItem("hwt-token")) {
            headers["hwt-token"] = sessionStorage.getItem("hwt-token");
        }

        axios({
            url: url,
            method: method,
            responseType: "blob",
            data: pParameter,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                if (loadingFlag) {
                    loading.close();
                }
                if (response.status >= 200 && response.status < 300) {
                    console.log(response);
                    if (response.headers["content-disposition"] != null) {
                        let fileName = window.decodeURI(
                            response.headers["content-disposition"].split(
                                "="
                            )[1]
                        );
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(
                            new Blob([response.data], {
                                type:
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                            })
                        );
                        link.target = "_blank";
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if (
                        response.headers["content-type"] ==
                        "application/json;charset=UTF-8"
                    ) {
                        console.log(1465456165);
                        let reader = new FileReader(); // 创建读取文件对象
                        reader.readAsText(new Blob([response.data]), "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
                        reader.addEventListener("loadend", function() {
                            //
                            let res = JSON.parse(reader.result); // 返回的数据
                            response.data = res;
                            if (!res.success) {
                                _this
                                    .$alert(res.message, "提示", {
                                        confirmButtonText: "关闭",
                                        type: "warning"
                                    })
                                    .then(() => {})
                                    .catch(() => {});
                            }

                            //console.log(res,'返回结果数据') // { name: "小明" }
                        });
                        console.log(response);
                        pSuccessCallback.apply(_this, response.data);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "请求异常：" + response.status,
                        type: "warning"
                    });
                    // sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "通讯异常[" + response.status + "]",
                        type: "warning"
                    });
                }
                pSuccessCallback.apply(_this);
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                if (loadingFlag) {
                    loading.close();
                }

                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
            });
    },
    // 暂未使用
    downLoad: function(
        url,
        pParameter,
        pSuccessCallback,
        pErrorCallback,
        method = "post"
    ) {
        if (process.env.NODE_ENV === "development") {
            url = "/api" + url; // 测试环境加上前缀，为了config/index.js里的测试环境代理proxyTable配置
        }
        var _this = this;
        // const loading = this.$loading({
        //     lock: true,
        //     text: "Loading",
        //     spinner: "el-icon-loading",
        //     background: "rgba(0, 0, 0, 0.7)"
        // });

        let headers = {};
        if (sessionStorage.getItem("user-token")) {
            headers["hwt-token"] = sessionStorage.getItem("user-token");
        }

        this.$http({
            url: url,
            method: method,
            responseType: "blob",
            data: pParameter,
            headers: headers,
            _self: this
        })
            .then(function(response) {
                // console.log(response);
                //loading.close();
                if (response.status == 200) {
                    console.log(response);
                    if (response.headers["content-disposition"] != null) {
                        let fileName = window.decodeURI(
                            response.headers["content-disposition"].split(
                                "="
                            )[1]
                        );
                        console.log(fileName);
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(
                            new Blob([response.data], {
                                type: "application/x-download"
                            })
                        );
                        link.target = "_blank";
                        link.download = fileName;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if (
                        response.headers["content-type"] ==
                        "application/json;charset=UTF-8"
                    ) {
                        console.log(1465456165);
                        let reader = new FileReader(); // 创建读取文件对象
                        reader.readAsText(new Blob([response.data]), "utf-8"); // 设置读取的数据以及返回的数据类型为utf-8
                        reader.addEventListener("loadend", function() {
                            //
                            let res = JSON.parse(reader.result); // 返回的数据
                            response.data = res;
                            if (!res.success) {
                                _this
                                    .$alert(res.message, "提示", {
                                        confirmButtonText: "关闭",
                                        type: "warning"
                                    })
                                    .then(() => {})
                                    .catch(() => {});
                            }

                            //console.log(res,'返回结果数据') // { name: "小明" }
                        });
                        console.log(response);
                        pSuccessCallback.apply(_this, response.data);
                    }
                } else if (response.status == 404) {
                    _this.$message({
                        showClose: true,
                        message: "请求异常：" + response.status,
                        type: "warning"
                    });
                    sessionStorage.clear();
                } else {
                    _this.$message({
                        showClose: true,
                        message: "通讯异常[" + response.status + "]",
                        type: "warning"
                    });
                    if (pErrorCallback != undefined) {
                        pErrorCallback.apply(_this);
                    }
                }
                pSuccessCallback.apply(_this);
            })
            .catch(function(err) {
                console.log("通讯-回调处理异常：");
                console.log(err);
                console.log(err.response.status);
                //loading.close();
                _this.$message({
                    showClose: true,
                    message: "通讯异常[" + err.response.status + "]",
                    type: "warning"
                });
                if (pErrorCallback != undefined) {
                    pErrorCallback.apply(_this);
                }
            });
    },
    /**
     * 格式化金额（千分位）
     */
    fmoney: function(num) {
        //参数说明：num 要格式化的数字 n 保留小数位
        if (!num) {
            if (num === 0) {
                num = String(num.toFixed(2));
            } else {
                num = "";
            }
            return num;
        }

        if (typeof num == "string") {
            num = parseFloat(num);
        }

        num = String(num.toFixed(2));
        var re = /(-?\d+)(\d{3})/;
        while (re.test(num)) {
            num = num.replace(re, "$1,$2");
        }
        return num;
    },
    /**
     * 格式化时间
     */
    timeFormat: function(value, format) {
        if (!value) {
            return "";
        }
        let date = new Date(value);
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let h = date.getHours();
        let min = date.getMinutes();
        let s = date.getSeconds();
        let result = "";
        if (format == undefined) {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }:${min < 10 ? "0" + min : min}:${s < 10 ? "0" + s : s}`;
        }
        if (format == "yyyy-mm-dd hh:mm") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }:${min < 10 ? "0" + min : min}`;
        }
        if (format == "yyyy-mm-dd hh") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d} ${
                h < 10 ? "0" + h : h
            }`;
        }
        if (format == "yyyy-mm-dd") {
            result = `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
        }
        if (format == "yyyymmdd") {
            result = `${y}${m < 10 ? "0" + m : m}${d < 10 ? "0" + d : d}`;
        }
        if (format == "yyyy-mm") {
            result = `${y}-${m < 10 ? "0" + m : m}`;
        }
        if (format == "mm-dd") {
            result = `${mm < 10 ? "0" + mm : mm}:${ddmin < 10 ? "0" + dd : dd}`;
        }
        if (format == "dd hh:mm") {
            result = `${d < 10 ? "0" + d : d} ${h < 10 ? "0" + h : h}:${
                min < 10 ? "0" + min : min
            }`;
        }
        if (format == "hh:mm") {
            result = `${h < 10 ? "0" + h : h}:${min < 10 ? "0" + min : min}`;
        }
        if (format == "yyyy") {
            result = `${y}`;
        }
        return result;
    },
    formatMilliseconds(ms) {
        if (typeof ms !== "number" || isNaN(ms)) {
            return "无效输入";
        }

        // 处理负数
        const isNegative = ms < 0;
        const absoluteMs = Math.abs(ms);

        // 计算各个时间单位
        const seconds = Math.floor(absoluteMs / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        // 获取各单位的实际值
        const daysValue = days;
        const hoursValue = hours % 24;
        const minutesValue = minutes % 60;
        const secondsValue = seconds % 60;

        // 构建结果数组，只包含非零值
        const parts = [];

        if (daysValue > 0) {
            parts.push(`${daysValue}天`);
        }
        if (hoursValue > 0) {
            parts.push(`${hoursValue}小时`);
        }
        if (minutesValue > 0) {
            parts.push(`${minutesValue}分`);
        }
        if (secondsValue > 0) {
            parts.push(`${secondsValue}秒`);
        }

        // 如果所有值都是0，显示0秒
        if (parts.length === 0) {
            return "0秒";
        }

        // 添加负号（如果需要）并拼接结果
        return (isNegative ? "-" : "") + parts.join("");
    },
    /**
     * 全局判断功能权限
     */
    funAuth: function(key) {
        return funAll.find(item => {
            return item.url == key;
        });
    },
    isImg: function(fileKey) {
        if (
            fileKey.endWith(".jpg") ||
            fileKey.endWith(".jpeg") ||
            fileKey.endWith(".png") ||
            fileKey.endWith(".JPG") ||
            fileKey.endWith(".JPEG") ||
            fileKey.endWith(".PNG")
        ) {
            return true;
        } else {
            return false;
        }
    },
    isDoc: function(fileKey) {
        if (
            fileKey.endWith(".pdf") ||
            fileKey.endWith(".doc") ||
            fileKey.endWith(".docx") ||
            fileKey.endWith(".PDF") ||
            fileKey.endWith(".DOC") ||
            fileKey.endWith(".DOCX")
        ) {
            return true;
        } else {
            return false;
        }
    },
    getNations: function() {
        return [
            "汉族",
            "蒙古族",
            "回族",
            "藏族",
            "维吾尔族",
            "苗族",
            "彝族",
            "壮族",
            "布依族",
            "朝鲜族",
            "满族",
            "侗族",
            "瑶族",
            "白族",
            "土家族",
            "哈尼族",
            "哈萨克族",
            "傣族",
            "黎族",
            "傈僳族",
            "佤族",
            "畲族",
            "高山族",
            "拉祜族",
            "水族",
            "东乡族",
            "纳西族",
            "景颇族",
            "柯尔克孜族",
            "土族",
            "达斡尔族",
            "仫佬族",
            "羌族",
            "布朗族",
            "撒拉族",
            "毛南族",
            "仡佬族",
            "锡伯族",
            "阿昌族",
            "普米族",
            "塔吉克族",
            "怒族",
            "乌孜别克族",
            "俄罗斯族",
            "鄂温克族",
            "德昂族",
            "保安族",
            "裕固族",
            "京族",
            "塔塔尔族",
            "独龙族",
            "鄂伦春族",
            "赫哲族",
            "门巴族",
            "珞巴族",
            "基诺族"
        ];
    },
    nameChar: function(val) {
        if (val) {
            let begin = 0,
                end = 0;
            if (val.length < 2) {
                begin = 0;
                end = 1;
            } else {
                begin = val.length - 2;
                end = val.length;
            }
            return val.substring(begin, end);
            // return val.substring(0, 1);
        } else {
            return "?";
        }
    },
    lastChar: function(val) {
        if (val) {
            let begin = val.length - 1;
            let end = val.length;
            return val.substring(begin, end);
            // return val.substring(0, 1);
        } else {
            return "?";
        }
    },
    nameToColor: function(name) {
        var str = "";
        for (var i = 0; i < name.length; i++) {
            str += parseInt(name[i].charCodeAt(0), 10).toString(16);
        }

        // 方案一
        // while (str.length < 8) {
        //     str += str;
        // }
        // str = str.slice(1, 7);

        // 方案二
        const colors = [
            "#F44336",
            "#E91E63",
            "#9C27B0",
            "#673AB7",
            "#3F51B5",
            "#2196F3",
            "#03A9F4",
            "#00BCD4",
            "#009688",
            "#4CAF50",
            "#8BC34A",
            "#CDDC39",
            "#FFEB3B",
            "#FFC107",
            "#FF9800",
            "#FF5722",
            "#795548",
            "#2E8B57",
            "#607D8B",
            "#333333",
            "#67C23A",
            "#E6A23C",
            "#F56C6C",
            "#000080",
            "#FF4081",
            "#9575CD",
            "#7986CB",
            "#64B5F6",
            "#4DD0E1",
            "#AED581",
            "#81C784",
            "#E57373"
        ];
        let t = 0;
        str.split("").forEach(function(n, i) {
            t += parseInt(n, 16);
        });
        t = t % 32;
        return colors[t];
    },
    makeTkey: function(prefix) {
        let n = 4;
        var str = "abcdefghijklmnopqrstuvwxyz0123456789";
        var result = "";
        for (var i = 0; i < n; i++) {
            result += str[parseInt(Math.random() * str.length)];
        }
        result = prefix + new Date().getTime() + result;
        // console.log(result);
        return result;
    },
    generateGradientColorCode: function(numColors, startColor, endColor) {
        let colors = [];
        for (let i = 0; i < numColors; i++) {
            let color = [];
            for (let j = 0; j < 3; j++) {
                let value =
                    (i / (numColors - 1)) * (endColor[j] - startColor[j]) +
                    startColor[j];
                color.push(Math.floor(value));
            }
            colors.push(`rgb(${color[0]}, ${color[1]}, ${color[2]})`);
        }
        return colors;
    },
    generateStageColors: function(numColors) {
        let startColor = [100, 194, 58];
        let midColor = [255, 220, 0];
        let endColor = [255, 40, 0];

        let step1 = numColors / 2;
        let colors1 = this.generateGradientColorCode(
            step1,
            startColor,
            midColor
        );

        let step2 = numColors - step1 + 1;
        let colors2 = this.generateGradientColorCode(step2, midColor, endColor);

        return colors1.concat(colors2.slice(1));
    },
    inputAmount: function(value) {
        return value
            .replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3")
            .replace(/[^\d.]/g, "");
    },
    openPage: function(url) {
        window.open(url, "_blank");
    },
    downloadFile: function(url) {
        let fileName = url.substring(url.lastIndexOf("/") + 1);

        const element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("download", fileName);
        element.setAttribute("target", "_blank");

        // 触发点击
        document.body.appendChild(element);
        element.click();

        // 然后移除
        document.body.removeChild(element);
    },
    getRandomInt: function(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    },
    numToLetter: function(num) {
        if (num < 0 || num > 25) {
            throw new Error("Number must be between 0 and 25.");
        }
        return String.fromCharCode(65 + num);
    },
    qstAnswerFmt: function(q) {
        if (q.type == 1) {
            let num = parseInt(q.answer);
            return String.fromCharCode(65 + num);
        } else if (q.type == 2) {
            let arr = JSON.parse(q.answer);
            return arr.map(n => String.fromCharCode(65 + n)).join(",");
        } else if (q.type == 3) {
            return q.answer;
        }
    },

    /**
     * 智能格式化图表数值
     * @param {number} value - 原始数值
     * @param {Object} options - 配置选项
     * @param {boolean} [options.removeZeroDecimal=true] - 是否移除小数部分的0
     * @param {number} [options.precision=2] - 最大小数位数
     * @returns {string} 格式化后的字符串
     */
    smartFormat(value, options = {}) {
        const { removeZeroDecimal = true, precision = 2 } = options;

        // 处理负值
        const sign = value < 0 ? "-" : "";
        const absValue = Math.abs(value);

        // 定义单位转换规则
        const units = [
            { threshold: 1e8, symbol: "亿", divisor: 1e8 },
            { threshold: 1e4, symbol: "万", divisor: 1e4 },
            { threshold: 1e3, symbol: "千", divisor: 1e3 }
        ];

        // 查找匹配的单位
        const matchedUnit = units.find(unit => absValue >= unit.threshold);

        if (matchedUnit) {
            const scaledValue = absValue / matchedUnit.divisor;

            // 动态确定小数位数
            let decimalPlaces = precision;
            if (scaledValue >= 100) decimalPlaces = 0;
            else if (scaledValue >= 10) decimalPlaces = 1;

            let formatted = scaledValue.toFixed(decimalPlaces);

            // 可选：移除末尾的零和小数点
            if (removeZeroDecimal) {
                // formatted = formatted.replace(/(\.0*|(?<=\.\d*?)0*)$/, "");
                formatted = formatted.replace(/\.0+$/, ""); // 1.000 → 1
                formatted = formatted.replace(/(\..*?)0+$/, "$1"); // 1.200 → 1.2
                formatted = formatted.replace(/\.$/, ""); // 123. → 123
            }

            return `${sign}${formatted}${matchedUnit.symbol}`;
        }

        // 小于最小单位直接返回原始值
        return `${sign}${absValue}`;
    },

    /**
     * 生成 ECharts yAxis 的 formatter 函数
     * @param {Object} options - 格式化选项
     * @returns {Function} 适用于 ECharts 的 formatter 函数
     */
    yAxisFormatter(options = {}) {
        return value => {
            return this.smartFormat(value, options);
        };
    },

    /**
     * 获取预配置的 yAxis 对象（可选）
     * @param {Object} options - 格式化选项
     * @returns {Object} ECharts yAxis 配置对象
     */
    getYAxisConfig(options = {}) {
        return {
            type: "value",
            axisLabel: {
                formatter: this.yAxisFormatter(options)
            }
        };
    },
    calcPct: function(val1, val2) {
        if (!val1 || val2 === 0 || !val2) {
            return 0.0; // Return 0.00 to maintain two decimal places
        }
        const result = (val1 / val2) * 100;
        return Number(result.toFixed(2)); // Round to 2 decimal places and convert back to number
    },
    calcAge: function(testDate, birthDate) {
        // 此处判断testDate如果为空，则赋值当前时间
        testDate = testDate || new Date().toISOString();

        if (!testDate || !birthDate) {
            return '';
        }
        // 解析日期字符串为 Date 对象
        const test = new Date(testDate.substring(0, 10));
        const birth = new Date(birthDate.substring(0, 10));

        // 检查日期有效性
        if (isNaN(test.getTime()) || isNaN(birth.getTime())) {
            throw new Error("Invalid date format. Expected format: YYYY-MM-DD");
        }

        // 计算年份差
        let age = test.getFullYear() - birth.getFullYear();

        // 获取月份和日期
        const testMonth = test.getMonth();
        const testDay = test.getDate();
        const birthMonth = birth.getMonth();
        const birthDay = birth.getDate();

        // 判断是否已过生日
        if (
            testMonth < birthMonth ||
            (testMonth === birthMonth && testDay < birthDay)
        ) {
            age--; // 未过生日则年龄减一
        }

        return age;
    }
};



// WEBPACK FOOTER //
// ./src/js/library.js